import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getRequest, postRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'
import MappingItem from './MappingItem'
import ReferenceSelector from './ReferenceSelector'
import { ConnectorViewMappingContext } from './context/context'
import { ProgresSpinner } from '../../common/ProgresSpinner'

const ConnectorMappingForm = (props) => {
  const [connVwMpState, dispatch] = useContext(ConnectorViewMappingContext)

  const { connector_view, vehicle } = useParams()
  const [state, setState] = useState({
    activeTab: 'pending',
    referenceSelectorVisible: false,
    loader: false,
  })
  const [connectors, setConnectors] = useState([])

  useEffect(() => {
    getConnectorsData()
  }, [])

  const getConnectorsData = async () => {
    setState({ ...state, loader: true })
    let res = await getRequest(
      `/api/connector_views/connectors/${connector_view}/`
    )
    setConnectors(res.data)
    setState({ ...state, loader: false })
  }

  const toggleTabs = () => {
    const activeTab = state.activeTab === 'pending' ? 'autoMapped' : 'pending'
    setState({ ...state, activeTab })
  }

  const toggleRefSelector = () => {
    // let { referenceSelectorVisible } = state
    // referenceSelectorVisible = referenceSelectorVisible ? false : true
    // setState({ ...state, referenceSelectorVisible: !referenceSelectorVisible })
  }

  const onSelectMapping = (connector) => {
    dispatch({
      type: 'select_mapping',
      data: {
        connector: connector,
        svg_group_reference: connector.svg_group_reference,
        selected_reference: connector.auto_mapped,
      },
    })
  }

  const updateMapping = async (connector, ref, hide_sidebar = true) => {
    let res = await postRequest(
      `/api/connector_views/save_connector_view_mapping/${connector_view}/`,
      {
        name: connector.name,
        connector: connector.id,
        reference: ref,
        prev_reference: connector.auto_mapped,
      }
    )

    dispatch({
      type: 'update_mapping_and_reference',
      data: {
        connector: hide_sidebar
          ? {}
          : {
              ...connector,
              auto_mapped: null,
            },
        svg_group_reference: null,
        selected_reference: null,
        connector_view: {
          ...connVwMpState.connector_view,
          references: res.svg_group_reference,
        },
      },
    })

    getConnectorsData()
  }

  const { activeTab, referenceSelectorVisible } = state

  const unmappedRefs = connVwMpState?.connector_view?.group_ids?.filter(
    (ref) => !connectors.map((c) => c.reference).includes(ref)
  )

  let pendingLink, autoMappedLink, connectorsToRender
  const pendingConnectors =
    connectors?.length > 0 ? connectors?.filter((ctr) => !ctr.auto_mapped) : []
  const mappedConnectors =
    connectors?.length > 0 ? connectors?.filter((ctr) => ctr.auto_mapped) : []

  const highLighted = 'font-bold text-white border-white'
  const faded = 'font-normal text-gray-600 border-gray-600'

  if (activeTab === 'pending') {
    autoMappedLink = faded
    pendingLink = highLighted
    connectorsToRender = pendingConnectors
  } else {
    autoMappedLink = highLighted
    pendingLink = faded
    connectorsToRender = mappedConnectors
  }

  return (
    <div className="w-1/5 items-stretch flex-grow flex flex-col">
      {connVwMpState?.connector?.id ? (
        <ReferenceSelector
          connector={connVwMpState?.connector}
          unmappedReferences={unmappedRefs}
          onClick={(connector, ref, hide_sidebar) => {
            updateMapping(connector, ref, hide_sidebar)
          }}
          sid={vehicle}
          connectorViewId={connector_view}
        />
      ) : (
        <div
          className={`flex-grow flex-col flex items-stretch ${
            referenceSelectorVisible ? 'hidden' : ''
          }`}
        >
          <div className="w-full flex flex-row">
            <div
              onClick={toggleTabs}
              className={`border-b-2 p-4 w-1/2 text-center cursor-pointer ${pendingLink}`}
            >
              Pending({pendingConnectors.length})
            </div>
            <div
              onClick={toggleTabs}
              className={`border-b-2 p-4 w-1/2 text-center cursor-pointer ${autoMappedLink}`}
            >
              Mapped({mappedConnectors.length})
            </div>
          </div>

          <div className="mt-6 px-1 flex-auto overflow-auto h-0">
            <div className="w-full bg-tracer-lt-blue text-white font-normal rounded-t pl-1">
              Select Connector
            </div>

            {connectorsToRender?.length < 1 ? (
              <div className="flex flex-col flex-grow items-center bg-white w-full px-2 py-3 border-b border-tracer-dark-blue cursor-pointer group hover:bg-blue-100">
                {state?.loader ? (
                  <ProgresSpinner caption="Loading Connectors" />
                ) : (
                  'Data not available'
                )}
              </div>
            ) : (
              connectorsToRender.map((connector, idx) => (
                <MappingItem
                  connector={connector}
                  key={idx}
                  onClick={() => onSelectMapping(connector)}
                />
              ))
            )}
          </div>
        </div>
      )}
    </div>
  )
}

ConnectorMappingForm.propTypes = {}

export default ConnectorMappingForm
